import React 							from 'react';
import ReactDOM 						from 'react-dom';

import BLComponent						from '../core/_BLComponent.jsx';

export default class SelectSourceOptions extends BLComponent 
{
	render() {
		const sourceFrom = this.props.data.sourceFrom;

		return(
			<React.Fragment>
				<option value="0">BrickLink data</option>
				<option value="1">LEGO data</option>
			</React.Fragment>
		)
	}
}